export default __webpack_public_path__ + "static/media/servicies-renewal.icon.0e39bc2b.svg";